<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Push Notification List <span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn" (click)="exportExcel()"> <span><img src="../../../assets/images/backend-image/header/exportIcon.svg"
							alt=""></span>
					Export</button>
				<button class="addBTn" (click)="addNewPushNotification()"> <span><img
							src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> New</button>
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
							placeholder="Select Field" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<button (click)="loadPushNotifications(lastTableLazyLoadEvent)" class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button (click)="clear()" class="clearFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>

					</li>
				</ul>
			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table class=" expandable" #dt [value]="pushNotificationList" [paginator]="true" [rows]="10"
						[lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
						(onLazyLoad)="loadPushNotifications($event)" [totalRecords]="totalRecords" [loading]="loading"
						[rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pfrozencolumn="" class="titleTD" pSortableColumn="name">
									<div class="p-d-flex p-jc-between p-ai-center">
										Name
										<p-sortIcon field="name"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="notificationHeaderName" class="notificationHeaderNameTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Header Name
										<p-sortIcon field="notificationHeaderName"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="notificationIcon" class="notificationIconTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Icon
										<p-sortIcon field="notificationIcon"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="description" class="descriptionTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Description
										<p-sortIcon field="description"></p-sortIcon>
									</div>
								</th>
								<th pfrozencolumn="" class="slugTd" pSortableColumn="slug">
									<div class="p-d-flex p-jc-between p-ai-center">
										Slug
										<p-sortIcon field="slug"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="status" class="statusTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="type" class="pushNotificationTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Type
										<p-sortIcon field="type"></p-sortIcon>
									</div>
								</th>

								<th pSortableColumn="module" class="moduleTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Module
										<p-sortIcon field="module"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="appType" class="appTypeTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										App Type
										<p-sortIcon field="appType"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_at" class="createdDateTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Date of Creation
										<p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_by" class="CreatedByTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Created By
										<p-sortIcon field="created_by"></p-sortIcon>
									</div>
								</th>
								<th class="col-150" pSortableColumn="updated_at" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Last Modified On
										<p-sortIcon field="updated_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_by" class="col-200" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Last Modified By
										<p-sortIcon field="updated_by"></p-sortIcon>
									</div>
								</th>
								<th class="text-nowrap p-element p-frozen-column actionTD" pfrozencolumn=""
									alignfrozen="right"> 
										Action 
								</th>
							</tr>
							<tr>
								<th [ngSwitch]="name" pfrozencolumn="" class="titleTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'name', 'contains')"
										[value]="dt.filters['name'] ? dt.filters['name'].value : ''" />
								</th>

								<th [ngSwitch]="notificationHeaderName" class="notificationHeaderNameTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'notificationHeaderName', 'contains')"
										[value]="dt.filters['notificationHeaderName'] ? dt.filters['notificationHeaderName'].value : ''" />
								</th>

								<th class="notificationIconTD"></th>

								<th [ngSwitch]="description" class="descriptionTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'description', 'contains')"
										[value]="dt.filters['description'] ? dt.filters['description'].value : ''" />
								</th>
								<th [ngSwitch]="slug" pfrozencolumn="" class="slugTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'slug', 'contains')"
										[value]="dt.filters['slug'] ? dt.filters['slug'].value : ''" />
								</th>

								<th [ngSwitch]="status" class="statusTD">
									<p-dropdown appendTo="body" #pDropDownId1 [options]="statuses"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
										placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>

								<th [ngSwitch]="status" class="pushNotificationTD">
									<p-dropdown appendTo="body" #pDropDownId2 [options]="pushNotificationTypes"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'pushNotificationType', 'equals')"
										placeholder="Select Type" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>



								<th [ngSwitch]="module" class="moduleTd">
									<p-dropdown appendTo="body" #pDropDownId3 [options]="pushNotificationModules"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'module', 'equals')"
										placeholder="Select Module" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>


								<th [ngSwitch]="appType" class="appTypeTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-dropdown appendTo="body" #pDropDownId4 [options]="pushNotificationAppTypes"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'appType', 'equals')"
										placeholder="Select App Type" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>

								<th [ngSwitch]="created_at" class="createdDateTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
										inputId="calendar" dateFormat="dd-mm-yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'created_at', 'dateIs')"
										[showIcon]="true" appendTo="body" monthNavigator="true" yearNavigator="true"
										yearRange="2000:2030" showButtonBar="true" [(ngModel)]="calvalue"></p-calendar>
								</th>
								<th [ngSwitch]="createdby" class="CreatedByTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'createdby', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['createdby'] ? dt.filters['createdby'].value : ''" />
								</th>
								<th [ngSwitch]="updated_at" class="updatedTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
										inputId="calendar" dateFormat="dd-mm-yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
										[showIcon]="true" appendTo="body" showButtonBar="true" monthNavigator="true"
										yearNavigator="true" yearRange="2000:2030" showButtonBar="true"
										[(ngModel)]="ucalvalue">
									</p-calendar>
								</th>

								<th [ngSwitch]="updatedby" class="ModifiedbyTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'updatedby', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['updatedby'] ? dt.filters['updatedby'].value : ''" />
								</th>

								<th class="text-nowrap p-element p-frozen-column actionTD" pfrozencolumn=""
									alignfrozen="right">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-pushNotification>
							<tr class="p-selectable-row">
								<td pfrozencolumn="" class="titleTD">
									<span class="textOverFlow1">
										{{pushNotification?.name}}
									</span>
								</td>

								<td class="notificationHeaderNameTD">
									{{ pushNotification?.notificationHeaderName }}
								</td>

								<td class="notificationIconTD" style="text-align: center;
    justify-content: center;">
									<img *ngIf="pushNotification?.notificationIconUrl" 
										[src]="pushNotification?.notificationIconUrl" 
										alt="Notification Icon" 
										style="max-width: 38px; max-height: 38px; border: 1px solid #ddd; border-radius: 4px; padding: 2px; cursor: pointer;"
										[pTooltip]="'Click to view full size'" 
										tooltipPosition="top"
										(click)="viewIconFullSize(pushNotification?.notificationIconUrl)">
									<span *ngIf="!pushNotification?.notificationIconUrl" style="color: #999;">No Icon</span>
								</td>

								<td class="descriptionTd">
									{{ pushNotification?.description }}
								</td>
								<td pfrozencolumn="" class="slugTd">
									<span class="textOverFlow1">
										{{pushNotification?.slug}}
									</span>
								</td>
								<td class="statusTD">
									<div class="swichTable">
										<p-inputSwitch [(ngModel)]="pushNotification.status"
											(onChange)="changeStatus(pushNotification)"></p-inputSwitch>
										<div class="label activeText" *ngIf="pushNotification.status">
											Active
										</div>
										<div class="label InActiveText" *ngIf="!pushNotification.status">
											Inactive
										</div>
									</div>

									<!-- <p-inputSwitch [(ngModel)]="pushNotification.status"
										(onChange)="changeStatus(pushNotification)"></p-inputSwitch> -->
								</td>

								<td class="pushNotificationTD">
									{{ pushNotification?.type }}
								</td>



								<td class="moduleTd">
									{{ pushNotification?.module }}
								</td>

								<td class="appTypeTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{ pushNotification?.appType }}
								</td>

								<td class="createdDateTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{pushNotification.created_at | date: 'dd-MM-yyyy'}}
								</td>
								<td class="CreatedByTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{pushNotification.createdBy}}
								</td>
								<td class="col-150" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{pushNotification.updated_at | date: 'dd-MM-yyyy'}}
								</td>

								<td class="col-200" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{pushNotification.updatedBy}}
								</td>

								<td class="text-nowrap p-element p-frozen-column actionTD" pfrozencolumn=""
									alignfrozen="right">
									<ul class="actionList">
										<li>
											<button (click)="editPushNotification(pushNotification.id)"
												class="editBtn"><img
													src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
										</li>
										<li>
											<button (click)="deletePushNotification(pushNotification)" class="deleteBtn"><img
													src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
										</li>
									</ul>

									<!-- <button pButton pRipple icon="pi pi-pencil"
										class="p-button-rounded p-button-success p-mr-2"
										(click)="editPushNotification(pushNotification.id)"></button>
									<button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
										(click)="deletePushNotification(pushNotification)"></button> -->
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">Push Notifications not found.</td>
							</tr>
						</ng-template>

					</p-table>
				</div>
			</div>

		</div>
	</div>
</div>

<p-confirmDialog [style]="{width:'400px'}" id="confirmDialog"></p-confirmDialog>

<p-dialog [(visible)]="displayIconDialog" [modal]="true" 
	[maximizable]="false" 
	[draggable]="false" 
	[resizable]="false"
	[showHeader]="false"
	[dismissableMask]="true"
	[style]="{width: '100vw', height: '100vh', margin: '0'}"
	[contentStyle]="{padding: '0', background: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center'}"
	styleClass="fullscreen-transparent-dialog">
	<div style="text-align: center; position: relative; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
		<button pButton type="button" icon="pi pi-times" 
			class="p-button-rounded p-button-danger p-button-text" 
			(click)="displayIconDialog = false"
			style="position: absolute; top: 20px; right: 20px; z-index: 1000; background: rgba(255,255,255,0.9);"></button>
		<img [src]="selectedIconUrl" alt="Notification Icon Full Size" 
			(click)="displayIconDialog = false"
			style="max-width: 90vw; max-height: 90vh; cursor: pointer; box-shadow: 0 4px 20px rgba(0,0,0,0.5); border-radius: 8px;">
	</div>
</p-dialog>